import { LayoutComponents } from "@jelly/lesson";
import variables from "../../../../../../../assets/styles/sass-resources.scss";

import config from "appConfig";

const components: LayoutComponents = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 6,
        rows: 3,
        rowsSize: [6, 1, 1],
        colsSize: [1.5, 1, 1, 1, 1, 1],
        colSpan: {
          "0:1": 5,
        },
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data:
                      "Double-casement window with a wooden frame; two casements 175 mm apart; the outer casement is a single-pane 6 mm glass with no seals; the inner casement is a double pane construction (6 mm glass / 14 mm gap / 6 mm glass) with seals</br></br>Rw =  51 dB",
                    formatter: "html",
                    scrollbars: false,
                    styles: {
                      color: variables["text-secondary"],
                      fontSize: "14px",
                      lineHeight: "18px",
                      fontWeight: 400,
                    },
                  },
                },
                styles: {
                  alignItems: "flex-start",
                  paddingTop: "50%",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/21/principle/window-1.svg`,
                  },
                },
                styles: {
                  padding: "10% 0",
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: "Original sound",
                    scrollbars: false,
                  },
                },
                styles: {
                  justifyContent: "flex-start",
                  fontSize: "14px",
                  fontWeight: 700,
                  lineHeight: "18px",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "primary",
                    text: "man",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/21/principle/source-man.wav`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "primary",
                    text: "woman",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/21/principle/source-woman.wav`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "primary",
                    text: "baby",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/21/principle/source-baby.wav`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "primary",
                    text: "car",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/21/principle/source-car.wav`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "primary",
                    text: "party",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/21/principle/source-party.wav`,
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: "Sound through the</br>door or window",
                    scrollbars: false,
                    formatter: "html",
                  },
                },
                styles: {
                  justifyContent: "flex-start",
                  fontSize: "14px",
                  fontWeight: 700,
                  lineHeight: "18px",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "secondary",
                    text: "man",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/21/principle/window-1-man.wav`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "secondary",
                    text: "woman",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/21/principle/window-1-woman.wav`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "secondary",
                    text: "baby",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/21/principle/window-1-baby.wav`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "secondary",
                    text: "car",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/21/principle/window-1-car.wav`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "secondary",
                    text: "party",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/21/principle/window-1-party.wav`,
                  },
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
